import { render } from "./CbPharmacyInfo.vue?vue&type=template&id=33ee0848&scoped=true&ts=true"
import script from "./CbPharmacyInfo.vue?vue&type=script&lang=ts"
export * from "./CbPharmacyInfo.vue?vue&type=script&lang=ts"

import "./CbPharmacyInfo.vue?vue&type=style&index=0&id=33ee0848&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ee0848"]])

export default __exports__